module.exports = __webpack_public_path__ + "static/img/step-migration-icon.0fc33f1a.png";